import React from "react";
import { connect } from "react-redux";

import { objectToArray, removeItem } from "utils";

function BackupPlanScheduleCustom(props) {
  const weekDays = props.enums.WeekDays.props;

  React.useEffect(() => {
    if (props.planSettings.scheduleInfo.weekDays.length === 0) {
      props.setPlanSettings({
        ...props.planSettings,
        scheduleInfo: { ...props.planSettings.scheduleInfo, weekDays: [] }
      });
    }
  }, []);

  const checkMontoFri = () =>
    props.planSettings.scheduleInfo.weekDays.length === 5 &&
    [1, 2, 3, 4, 5].every(day =>
      props.planSettings.scheduleInfo.weekDays.includes(day)
    );

  function updateDays(val) {
    let tempPlan = { ...props.planSettings };
    let weekDays = [...tempPlan.scheduleInfo.weekDays];
    if (props.planSettings.scheduleInfo.weekDays.includes(val.code)) {
      weekDays = removeItem(weekDays, weekDays.indexOf(val.code));
    } else {
      if (weekDays.length === 6) {
        tempPlan.scheduleInfo.type = 1; // setting plan type to 'Daily' if all days were selected and user is now selecting one more day
      }
      weekDays.push(val.code);
    }
    tempPlan.scheduleInfo.weekDays = weekDays.sort();
    props.setPlanSettings(tempPlan);
    if (checkMontoFri()) props.checkDaily(true);
  }

  return (
    <React.Fragment>
      <div class="idapp__schedule idapp-weekly__schedule id-hide">
        <label class="idapp-form__label">Backup start days:</label>
      </div>
      <div className="sche_backup_item custom random_schedule">
        <div className="days_wrap">
          {objectToArray(weekDays, { 1: "priority" }).map(val => (
            <div
              key={val.code}
              className={[
                "days_block",
                val.name + "__day",
                props.planSettings.scheduleInfo.weekDays.includes(val.code)
                  ? "active"
                  : null
              ].join(" ")}
              onClick={() => updateDays(val)}
            >
              {val.name}
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums
  };
}

export default connect(mapStateToProps)(BackupPlanScheduleCustom);
